// import Mmenu from "mmenu-js"; // full

//	Core
import Mmenu from 'mmenu-js/dist/core/oncanvas/mmenu.oncanvas.js';

//	Core add-ons
import offcanvas from 'mmenu-js/dist/core/offcanvas/mmenu.offcanvas.js';
import scrollBugFix from 'mmenu-js/dist/core/scrollbugfix/mmenu.scrollbugfix.js';
import theme from 'mmenu-js/dist/core/theme/mmenu.theme.js';

//	Add-ons
import navbars from 'mmenu-js/dist/addons/navbars/mmenu.navbars.js';

Mmenu.addons = {
    //	Core add-ons
    offcanvas,
    scrollBugFix,
    theme,

    //	Add-ons
    // backButton,
    // counters,
    // iconbar,
    // iconPanels,
    navbars,
    // pageScroll,
    // searchfield,
    // sectionIndexer,
    // setSelected,
    // sidebar
};

if (window) {
    window.Mmenu = Mmenu;
}

function mmenu(){

    // на десктопе клонируем верхнее меню, удалив из него все лишние классы
    if(!window.isMobile){
        const menuDesktop = document.querySelector('.menu-top_list');
        const menuDesktopWithoutClasses = removeAllClasses(menuDesktop);

        menuDesktopWithoutClasses.setAttribute('id', 'mmenu');
        document.querySelector('#panel-menu').append(menuDesktopWithoutClasses);

        function removeAllClasses(element) {
            if (!element || !element.nodeType || element.nodeName === "svg") {
                return null; // Возвращаем null, если элемент не существует или не является узлом DOM
            }

            const newElement = element.cloneNode(false); // Клонируем элемент без копирования его детей

            // Удаляем классы у текущего элемента
            if (newElement.nodeName === "UL" || newElement.nodeName === "LI" || newElement.nodeName === "A" || newElement.nodeName === "SPAN") {
                if(newElement.classList.contains('menu-top_item_selected') || newElement.classList.contains('menu-top__submenu-item_selected')){
                    newElement.className = 'selected';
                } else if(newElement.classList.contains('menu-top_item_active') || newElement.classList.contains('menu-top__submenu-item_active')){
                    newElement.className = 'active';
                } else {
                    newElement.className = '';
                }
            }

            // Рекурсивно обходим дочерние элементы текущего элемента и добавляем их к новому элементу без классов
            const children = element.childNodes;
            if (children && children.length > 0) {
                for (let i = 0; i < children.length; i++) {
                    const newChild = removeAllClasses(children[i]); // Рекурсивный вызов для каждого ребенка
                    if (newChild) {
                        newElement.appendChild(newChild); // Добавляем нового ребенка к новому элементу
                    }
                }
            }

            return newElement; // Возвращаем новый элемент без классов
        }
    }

    window.menu = new Mmenu("#mmenu", {
    // const menu = new Mmenu( "#mmenu", {
        theme: "dark",
        slidingSubmenus: false, // открывать подменю снизу / в виде скользящих меню
        navbar: false, // убрать сверху название меню
        navbars: [
            {
                position: "top",
                content: Array.from(document.querySelector("#mmenu-top-buttons").children)
            },
            // {
            //     "position": "top",
            //     "type": "tabs",
            //     "content": Array.from(document.querySelector("#mmenu-tabs").children)
            // },
            {
                use: (document.querySelector(".socials_mobile") ? true : false),
                position: "bottom",
                content: (document.querySelector(".socials_mobile") ? Array.from(document.querySelector(".socials_mobile").children) : null)
            },
        ],
        // "counters": true, // кол-во подразделов
        // setSelected: {
        //     hover: true // чтобы пункт меню был активным при наведении мышью (например, для десктопа).
        // },
    }, {
        classNames: {
            selected: (document.querySelector("body.item") ? "active": "selected"),
        },
        offCanvas: {
            page: {
                selector: ".page"
            },
        },
        language: "ru",
    });
}

export default mmenu;